/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { UserProfileDTO } from '../model/models';
import { UserProfileUpdateForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface UpdateProfiloServizioRequestParams {
    userProfileUpdateForm: UserProfileUpdateForm;
}


export interface ProfiloOperatoreServizioServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Lettura del proprio profilo identita\&#39;.
     * Audience: OP_SCUOLA o OP_CENTRO_COTTURA. Profilo mancante → 200 con DTO empty (D8 revisionato).
     * @endpoint get /api/v1/servizi/profilo
*/
    getProfiloServizio(extraHttpRequestParams?: any): Observable<UserProfileDTO>;

    /**
     * Aggiornamento (upsert) del proprio profilo identita\&#39;.
     * Audience operatori servizio. Auto-create se il profilo non esiste. CF editabile (D7 revisionato): operatori non federati possono dichiarare il CF.
     * @endpoint put /api/v1/servizi/profilo
* @param requestParameters
     */
    updateProfiloServizio(requestParameters: UpdateProfiloServizioRequestParams, extraHttpRequestParams?: any): Observable<UserProfileDTO>;

}
